import React from 'react';
import styles from './AuthMethodForm.module.scss';
import {AuthMethodType} from '../../model';
import {PasswordAuth} from '../PasswordAuth';
import {CodeAuth} from '../CodeAuth';

export type AuthMethodFormProps = {
  authMethod: AuthMethodType;
};

export const AuthMethodForm = ({authMethod}: AuthMethodFormProps) => {
  if (authMethod !== 'password' && authMethod !== 'code') {
    return null;
  }

  return (
    <div className={styles.formContainer}>
      {authMethod === 'password' && <PasswordAuth />}

      {authMethod === 'code' && <CodeAuth />}
    </div>
  );
};
